import TurndownService from "turndown";
export default function HtmlToMarkdown(content) {
    const turndownService = new TurndownService();
    const md = turndownService.turndown(content);
    return md;
}
